import { defineComponent, ref, computed, watch } from "vue";
import uniqueId from "./component-library253.mjs";
import Arrow from "./component-library4.mjs";
import LinkButton from "./component-library3.mjs";
import TransitionExpand from "./component-library83.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "accordion-item",
  props: {
    isSmall: { type: Boolean, default: false },
    isOpen: { type: Boolean, default: false },
    isOpenOnDesktop: { type: Boolean, default: false },
    role: { default: "region" }
  },
  emits: ["update:isOpen"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const uid = ref(uniqueId());
    const isOpenDerived = ref(props.isOpen);
    const ariaIsOpen = computed(() => {
      if (props.isOpenOnDesktop) {
        return true;
      }
      return isOpenDerived.value;
    });
    watch(
      () => props.isOpen,
      (newValue) => {
        isOpenDerived.value = newValue;
      }
    );
    watch(isOpenDerived, (newValue) => {
      emits("update:isOpen", newValue);
    });
    const toggleIsOpen = () => {
      isOpenDerived.value = !isOpenDerived.value;
    };
    const handleKeydown = (event) => {
      if (event.key === "Enter") {
        toggleIsOpen();
      }
    };
    return { __sfc: true, props, emits, uid, isOpenDerived, ariaIsOpen, toggleIsOpen, handleKeydown, Arrow, LinkButton, TransitionExpand };
  }
});
export {
  _sfc_main as default
};
